// extracted by mini-css-extract-plugin
export var table = "_wk-0";